
import React from 'react';

const OurStorySection = () => {
  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900">Our Story</h2>
            <div className="mt-6 text-gray-600 space-y-4">
              <p>
                AI Nexus was founded in 2023 by a team of AI researchers, engineers, and industry experts who recognized a growing gap between cutting-edge AI development and accessible public understanding.
              </p>
              <p>
                We believe that as AI increasingly shapes our world, it's crucial that everyone—from professionals to curious individuals—has access to accurate, understandable information about this transformative technology.
              </p>
              <p>
                What started as a small blog has grown into a comprehensive platform offering articles, analyses, and resources that bridge the gap between technical complexity and practical understanding.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <img
              src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
              alt="Team collaboration"
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStorySection;
